import type { ICurrencyBody } from '@/types/currency.types';
import type { IBodyTax } from '@/types/taxe.types';
import { reactive, ref } from 'vue';

export const currency_page = ref(1);
export const currency_id = ref(null);
export const form_currency_Body = reactive<ICurrencyBody>({
  name: '',
  label: '',
  description: '',
  isActive: true,
});

export const isAtcivatedWatchCurrency = ref(false);
export const isUpdateFromCurrency = ref(false);
export const isDeletedFromCurrency = ref(false);
